import _slicedToArray from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/slicedToArray.js";
import "core-js/modules/es6.regexp.constructor";
import _classCallCheck from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck.js";
import _createClass from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/createClass.js";
var defaultGroupSeperator = '&';
var defaultPairSeperator = '=';
/**
 * @example
 * ```typescript
 * const parser = new KVParser({
 *   groupSeperator: '&',
 *   pairSeperator: '=',
 *   canSkipEmpty: true,
 *   needDecode: true,
 * });
 * const params = parser.parse(location.query);
 * ```
 */

var KVParser = /*#__PURE__*/function () {
  /**
   *
   * @param options
   * @param options.groupSeperator 键值组分割符，比如a=1&b=2中的&
   * @param options.pairSeperator 键值对分割符，比如a=1&b=2中的=
   * @param options.canSkipEmpty 是否过滤值为空的键值对
   * @param options.needDecode 是否对值进行解码
   */
  function KVParser() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$groupSeperator = _ref.groupSeperator,
        groupSeperator = _ref$groupSeperator === void 0 ? defaultGroupSeperator : _ref$groupSeperator,
        _ref$pairSeperator = _ref.pairSeperator,
        pairSeperator = _ref$pairSeperator === void 0 ? defaultPairSeperator : _ref$pairSeperator,
        _ref$canSkipEmpty = _ref.canSkipEmpty,
        canSkipEmpty = _ref$canSkipEmpty === void 0 ? false : _ref$canSkipEmpty,
        _ref$needDecode = _ref.needDecode,
        needDecode = _ref$needDecode === void 0 ? true : _ref$needDecode;

    _classCallCheck(this, KVParser);

    this.groupSeperator = groupSeperator instanceof RegExp ? groupSeperator.source : groupSeperator;
    this.pairSeperator = pairSeperator instanceof RegExp ? pairSeperator.source : pairSeperator;
    this.canSkipEmpty = canSkipEmpty;
    this.needDecode = needDecode;
  }

  _createClass(KVParser, [{
    key: "parse",
    value: function parse(content) {
      if (typeof content !== 'string' || content === '') {
        return {};
      }

      var regexp = this.createPattern();
      var params = {};
      var matches;

      while (matches = regexp.exec(content)) {
        var _matches = matches,
            _matches2 = _slicedToArray(_matches, 4),
            k = _matches2[1],
            v = _matches2[3];

        var isEmpty = v === null || v === undefined || v === '';

        if (this.canSkipEmpty && isEmpty) {
          continue;
        }

        if (isEmpty) {
          params[k] = '';
        } else {
          params[k] = this.needDecode ? decodeURIComponent(v) : v;
        }
      }

      return params;
    }
  }, {
    key: "createPattern",
    value: function createPattern() {
      return new RegExp("([^(".concat(this.groupSeperator, ")(").concat(this.pairSeperator, ")]+)(").concat(this.pairSeperator, "([^(").concat(this.groupSeperator, ")(").concat(this.pairSeperator, ")]*))?"), 'g');
    }
  }]);

  return KVParser;
}();

export { KVParser as default };